import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import vuetify from './plugins/vuetify'

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAT6VQcf9Yj5SwWTiCaxz3GJQdADpGj6yY" 
  },
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
